import styled from 'styled-components';
import { COLOR } from '@latitude/core/utils/constants';
import { hexToRgb } from '@latitude/core/helpers';
import { buttonCSS } from '@latitude/button/Button.styled';
export var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "Linkstyled__StyledLink",
  componentId: "sc-fch6r8-0"
})(["border-bottom:solid 1px rgba(", ",0.5);box-sizing:border-box;cursor:pointer;color:", ";position:relative;text-decoration:none;transition:all 0.15s ease-in-out;&:hover{border-bottom:1px solid ", ";text-shadow:0 0 1px ", ";}&:active{top:1px;}", " ", " ", "};"], hexToRgb(COLOR.BLUE), COLOR.BLUE, COLOR.BLUE, COLOR.BLUE, function (_ref) {
  var noStyle = _ref.noStyle;
  return noStyle && "\n    border-bottom: none !important;\n    color: inherit !important;\n    text-shadow: none !important;\n    &:active {\n      top: 0 !important;\n    }\n  ";
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant && "\n    border-bottom: solid 1px rgba(" + hexToRgb(variant) + ", 0.5);\n    color: " + variant + ";\n\n    &:hover {\n      border-bottom: 1px solid " + variant + ";\n      text-shadow: 0 0 1px " + variant + ";\n    }\n  ";
}, function (_ref3) {
  var button = _ref3.button;
  return button && buttonCSS[button];
});